module.exports = __webpack_public_path__ + "img/index_kyzx.135fb655.png";